module.exports = __webpack_public_path__ + "media/src/public/img/success-e27c54efdee946528d7722d7ddd6ba0e.svg";